import React from "react";
import { useTranslation } from 'react-i18next';
import styles from "./css/ElectricityTab.module.css";
import { CityAttributes, Favorites } from "@/types";
import { GraphsCard } from "@/components/cards/GraphsCard";
import { ElectricityPowerGrid } from "./ElectricityPowerGrid";


interface ElectricityTabProps {
  favorites: Favorites;
  setFavorites: (favorites: Favorites) => void;
  cityAttributes: CityAttributes | null;
  colors: {
    vehicles: {
      [key: string]: string;
    };
    electric_vehicles: {
      [key: string]: string;
    };
    ev_charging_stations: {
      [key: string]: string;
    };
    electricity: {
      [key: string]: string;
    };
  };
}

const addUnitsToElectricityData = (electricityData: { [key: string]: number }): { value: number, unit: string, description: string }[] => {
  const unitsMap: { [key: string]: string } = {
    "הספק חשמלי במרחב מגורים": "MW",
    "הספק חשמלי שימושים אחרים": "MW",
    "הספק חשמלי טעינת רכבים": "MW",
    "הספק חשמלי לפי חברת חשמל": "MW",
    "מספר תחמשים": "",
  
    "תוספת הספק חשמלי במרחב מגורים": "MW",
    "תוספת הספק חשמלי שימושים אחרים": "MW",
    "תוספת הספק חשמלי טעינת רכבים": "MW",
    "תוספת הספק חשמלי לפי חברת חשמל": "MW",
  };

  return Object.entries(electricityData).map(([key, value]) => ({
    value,
    unit: unitsMap[key] || "",
    description: key
  }));
};



export const ElectricityTab: React.FC<ElectricityTabProps> = ({ favorites, setFavorites, cityAttributes, colors }) => {
  const { t } = useTranslation('ElectricityTab');
  
  // Dynamically extract years from electricity data
  const electricityYears = cityAttributes?.electricity ? Object.keys(cityAttributes.electricity).sort() : [];
  const currentYear = electricityYears[0] || "2025";
  const futureYear = electricityYears[1] || "2040";
  
  const setFavourite = (id: string, isFavourite: boolean) => {
    setFavorites({ ...favorites, [id]: isFavourite });
  };

  return (
    <div className={styles.container}>
      <GraphsCard 
          title={t('currentStatus')}
          children={
              <ElectricityPowerGrid gridItems={addUnitsToElectricityData(cityAttributes?.electricity?.[currentYear] || {})} />
          }
          disclaimer={{
          text: t('substationsDisclaimer'),
          type: "info"
        }}

          setFavourite={() => {}}
          id="currentDemand"
          isFavourite={false}
          showFavorite={false}
          size="big"
      />

      <GraphsCard 
          title={t('futureStatus')}
          children={
              <ElectricityPowerGrid gridItems={addUnitsToElectricityData(cityAttributes?.electricity?.[futureYear] || {})} />
          }
          disclaimer={{
                    text: t('substationsDisclaimer'),
                    type: "info"
                }}
          setFavourite={() => {}}
          id="futureDemand"
          isFavourite={false}
          showFavorite={false}
          size="veryBig"
      />
    </div>
  );
};
